import { ComboBoxDataSource } from "@/components/Shared/Dynamicform/ComboBoxDataSource";
import { Identity } from "../backend/userIdentity";
import { UserProfile } from "../backend/userProfile";
import { TierartZusatzRecord, deleteDatabase, deleteRecord, deleteUnsyncedDatabase, openDatabase, wildbookTable } from "../database/asyncDb";
import { LoaderStateServiceForRoot } from "../observables/loaderState";
import { isAllSynced } from "../serviceworker-related/Sync";
import { OfflineForms } from "@/components/Shared/Dynamicform/DynamicFormPreload";
import { AsyncRestClient } from "../backend/async/AsyncRestClient";
import { ObjectSearchDataSource } from "@/components/Shared/Dynamicform/ObjectSearchDataSource";
import { TierartRules } from "../serviceworker-related/TierartZusatzService";
import { DynamicGridRequest, DynamicGridRow } from "@/components/Shared/dynamicList/DynamicListTypes";
import { getDynamicGridFromApi } from "../serviceworker-related/DynamicGridServiceWorker";
import { Out } from "../frontent/clientMessage";
import { Resource } from "../resource/resource";
import { RefreshServerObjects } from "../resource/RefreshServerObjects";
import { loadWildBookTable } from "../serviceworker-related/LocalWildBookDataAccess";
import { reSyncWildBookApi } from "../serviceworker-related/ReSyncWildBook";
import { VersionControl } from "./VersionControl";
import { AsyncDbVersion } from "./asyncDbVersion";
import { version } from "vue";

export class ReorganizeDatabaseAfterChange {

    private static _loaderState: LoaderStateServiceForRoot


    public static async updateToNewVersion() {
      AsyncDbVersion.ensureCurrentDbVersion()
      const version = new VersionControl()
      if (await version.isOldVersion()) { 
        await this.updateToNewVersion_Old()
        return
      }

      await this.updateToNewVersion_New()
    }

    public static async updateToNewVersion_New() {
      if ( !this._loaderState) ReorganizeDatabaseAfterChange._loaderState = LoaderStateServiceForRoot.getLoaderStateService()
      ReorganizeDatabaseAfterChange._loaderState.changeLoaderState({isInProgress: true})

      this.infoMessage("updateToNewVersion_New: isUserRole")

      let isUser = Identity.isUserRole()
      await ReorganizeDatabaseAfterChange.deleteTables()

      try {
        if ( ! isUser) {
          const version = new VersionControl()
          const userId = await version.getTempId()
          const category = await version.getTempCategory()
          if ( userId && category)
          {
           if ( category === "User") {
            isUser = true
           }
          }

        }  
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`updateToNewVersion_New.IdentityDb: ${e}`)
      }


      this.infoMessage("updateToNewVersion_New: removeAllStores")
      await ReorganizeDatabaseAfterChange.removeAllStores()

      this.infoMessage("updateToNewVersion_New: RefreshServerObjects.resetAll")
      await RefreshServerObjects.resetAll()

      this.infoMessage("updateToNewVersion_New: AsyncDbVersion.ensureCurrentDbVersion")
      await AsyncDbVersion.ensureCurrentDbVersion()
      AsyncDbVersion.setUpdateDatabaseVersion(true)
      try {
        await openDatabase()
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`updateToNewVersion_New.OpenDatabase: ${e}`)
      }
      AsyncDbVersion.setUpdateDatabaseVersion(false)
      this.infoMessage("updateToNewVersion_New: AsyncDbVersion.ensureCurrentDbVersion (2)")
      await AsyncDbVersion.ensureCurrentDbVersion()

      if ( isUser) {
        this.infoMessage("updateToNewVersion_New: ReorganizeDatabaseAfterChange.loadWhenSynced()")
        await ReorganizeDatabaseAfterChange.loadWhenSynced()
      } else {
        this.infoMessage("updateToNewVersion_New: ReorganizeDatabaseAfterChange.loadWhenNotLoggedIn()")
         await ReorganizeDatabaseAfterChange.loadWhenNotLoggedIn()
      }

      const version = new VersionControl()

      this.infoMessage("updateToNewVersion_New: version.SaveVersionInfo()")
      await version.SaveVersionInfo()

      this.infoMessage("updateToNewVersion_New: version.updateDone()")
      await version.updateDone()

  }

   

    public static async updateToNewVersion_Old() {
        if ( !this._loaderState) ReorganizeDatabaseAfterChange._loaderState = LoaderStateServiceForRoot.getLoaderStateService()
        ReorganizeDatabaseAfterChange._loaderState.changeLoaderState({isInProgress: true})

        console.error("updateToNewVersion_Old")

        const isUser = Identity.isUserRole()
        const isSynced = await isAllSynced()

        await ReorganizeDatabaseAfterChange.deleteTables()

  
        if ( isSynced) {
            await ReorganizeDatabaseAfterChange.removeAllStores()
            await RefreshServerObjects.resetAll()
        } else {
            await ReorganizeDatabaseAfterChange.removeSyncedStores()
            await RefreshServerObjects.resetUserDefined()
        }

        await AsyncDbVersion.ensureCurrentDbVersion()
        AsyncDbVersion.setUpdateDatabaseVersion(true)
        try {
          await openDatabase()
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`updateToNewVErsion_Old: ${e}`)
        }
        AsyncDbVersion.setUpdateDatabaseVersion(false)
        await AsyncDbVersion.ensureCurrentDbVersion()

        if ( isUser) {
            if ( isSynced) {
                await ReorganizeDatabaseAfterChange.loadWhenSynced()
            } else {
                await ReorganizeDatabaseAfterChange.loadWhenNotSynced()
            }
        } else {
           await ReorganizeDatabaseAfterChange.loadWhenNotLoggedIn()
        }


        const version = new VersionControl()
        await version.SaveVersionInfo()
        await version.updateDone()

        //ReorganizeDatabaseAfterChange._loaderState.changeLoaderState({isInProgress: false})
    }

    private static async removeAllStores() {
      try {
        await deleteDatabase()
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`removeAllStores: ${e}`)
      }
    }

    
    private static async removeSyncedStores() {
      try {
        await deleteUnsyncedDatabase()
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`deleteUnsyncedDatabase: ${e}`)
      }
    }


    private static async deleteTables()
    {

      try {
        await deleteRecord(TierartZusatzRecord, "tierartZusatzData")
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`deleteTables.${TierartZusatzRecord}: ${e}`)
      }

      try {


          const dataRows = await loadWildBookTable() as any
          if ( dataRows === undefined ) return undefined
          for(const item of dataRows as DynamicGridRow[]) {
              await deleteRecord(wildbookTable , item.id ?? "")            
          }
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`deleteTables.${wildbookTable}: ${e}`)
      }
    }

    private static async loadWhenNotLoggedIn() {
        await ReorganizeDatabaseAfterChange.loadResources()   
        
        try {
          await ComboBoxDataSource.initNamedLists(true)
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotLoggedIn.ComboBoxDataSource.initNamedLists: ${e}`)
        }

        try {
          await OfflineForms.initOfflineForms()
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotLoggedIn.OfflineForms.initOfflineForms: ${e}`)
        }

    }


    private static async loadWhenNotSynced() {
        await ReorganizeDatabaseAfterChange.loadResources()
        
        try {
          await ComboBoxDataSource.initNamedLists(true)
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotSynced. ${e}`)
        }

        try {
          await OfflineForms.initOfflineForms()
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotSynced. ${e}`)
        }


        let isIdentity = false
        try {

          const identity = Identity.getIdentityViaCookie()
          if ( identity) {
            const userProfile: UserProfile = new UserProfile()
            await userProfile.ChangeLastLoginDate() 
            await userProfile.ChangeUserId(identity.getValue().UserId)
            await userProfile.ChangeRoles(identity.getValue().Roles)
            isIdentity = true
          }

        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotSynced.Identity ${e}`)
        }

        try {
          if ( ! isIdentity) {
            const version = new VersionControl()
            const userId = await version.getTempId()
            const category = await version.getTempCategory()
            if ( userId && category)
            {
              const userProfile: UserProfile = new UserProfile()
              await userProfile.ChangeLastLoginDate() 
              await userProfile.ChangeUserId(userId)
              await userProfile.ChangeRoles(category)
              isIdentity = true
            }
  
          }  
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.IdentityDb: ${e}`)
        }

        if (isIdentity) {
          try {

            try {
              await ComboBoxDataSource.initUserNamedList()
            } catch( e ) {
              ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotSynced.ComboBoxDataSource.initUserNamedList ${e}`)
            }
    
            try {
              await ObjectSearchDataSource.initUserNamedList()
            } catch( e ) {
              ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotSynced.ObjectSearchDataSource.initUserNamedList ${e}`)
            }
    
            try {
              await TierartRules.initRules()
            } catch( e ) {
              ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotSynced.TierartRules.initRules ${e}`)
            }
            
          } catch( e ) {
            ReorganizeDatabaseAfterChange.errorMessage(`loadWhenNotSynced: ${e}`)
          }
        }     
    }
   
    
      

    private static async loadWhenSynced() {
        await ReorganizeDatabaseAfterChange.loadResources()
        
        try {
          await ComboBoxDataSource.initNamedLists(false)
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.initNamedLists ${e}`)
        }

        try {
          await OfflineForms.initOfflineForms()
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.InitOfflineForms ${e}`)
        }

        let isIdentity = false
        try {

          const identity = Identity.getIdentityViaCookie()
          if ( identity) {
            const userProfile: UserProfile = new UserProfile()
            await userProfile.ChangeLastLoginDate() 
            await userProfile.ChangeUserId(identity.getValue().UserId)
            await userProfile.ChangeRoles(identity.getValue().Roles)
            isIdentity = true
          }

        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.Identity ${e}`)
        }

        try {
          if ( ! isIdentity) {
            const version = new VersionControl()
            const userId = await version.getTempId()
            const category = await version.getTempCategory()
            if ( userId && category)
            {
              const userProfile: UserProfile = new UserProfile()
              await userProfile.ChangeLastLoginDate() 
              await userProfile.ChangeUserId(userId)
              await userProfile.ChangeRoles(category)
              isIdentity = true
            }
  
          }  
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.IdentityDb: ${e}`)
        }


        if ( isIdentity) {
          try {      
            
            try {
              await ReorganizeDatabaseAfterChange.loadUserTables()
            } catch( e ) {
              ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.loadUserTables ${e}`)
            }
            
            try {
              await ComboBoxDataSource.initUserNamedList()
            } catch( e ) {
              ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.ComboBox.initUserNamedList ${e}`)
            }

            try {
              await ObjectSearchDataSource.initUserNamedList()
            } catch( e ) {
              ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.ObjectSearchDataSource.initUserNamedList ${e}`)
            }

            try {
              await TierartRules.initRules()            
            } catch( e ) {
              ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.TierartRules ${e}`)
            }
            
          } catch( e ) {
            ReorganizeDatabaseAfterChange.errorMessage(`loadWhenSynced.identity: ${e}`)
          }
        }     
    }

    private static async loadUserTables() {
      try {
        const request1: DynamicGridRequest = {
          userId: Identity.getIdentity().getValue().UserId,
          viewId: "fishBookEntriesWithDetail",
          activeData: true,
          pageSize: 1,
          revierNr: "",
          routeName: "FishBook",
          detailRouteName: "FishbookDetailRecord",
          page: "FischbuchEintragPachtDaten",
          form: "FischbuchEintragPacht",
          language: (await UserProfile.GetClientSettingsAsync()).language,
          detailId: 'FishbookDetailRecord',
          detailList: true,
          allRecords: true,
          lastRefreshDate: await RefreshServerObjects.getLastGridFormRefreshDate(),
          lastViewIdRefreshState: await RefreshServerObjects.getLastGridFishBookRefreshDate()
        }
        const gridObject1 = await getDynamicGridFromApi(request1, true)
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`loadUserTables: ${e}`)
      }

      try {
        const request2: DynamicGridRequest = {
          userId: Identity.getIdentity().getValue().UserId,
          viewId: "personProductsWithDetail",
          activeData: true,
          pageSize: 1,
          revierNr: "",
          routeName: "",
          detailRouteName: "",
          page: "1",
          language: (await UserProfile.GetClientSettingsAsync()).language,
          detailId: '',
          detailList: false,
          allRecords: true,
          lastRefreshDate: await RefreshServerObjects.getLastGridFormRefreshDate(),
          lastViewIdRefreshState: await RefreshServerObjects.getLastGridProductsRefreshDate()
        }
        const gridObject2 = await getDynamicGridFromApi(request2, true)
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`PersonProductsWithDetail: ${e}`)
      }

      try {
        const request3: DynamicGridRequest = {
          userId: Identity.getIdentity().getValue().UserId,
          viewId: "wildBookEntriesWithDetail",
          activeData: true,
          pageSize: 1,
          revierNr: "",
          routeName: "",
          detailRouteName: "",
          page: "1",
          language: (await UserProfile.GetClientSettingsAsync()).language,
          detailId: '',
          detailList: false,
          allRecords: true,
          lastRefreshDate: await RefreshServerObjects.getLastGridFormRefreshDate(),
          lastViewIdRefreshState: await RefreshServerObjects.getLastGridWildBookRefreshDate()
          
          }
          const gridObject3 = await getDynamicGridFromApi(request3, true)
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`wildbookEntriesWithDetails: ${e}`)
        }



      try {
        const wildBook = await reSyncWildBookApi()
      } catch( e ) {
        ReorganizeDatabaseAfterChange.errorMessage(`resyncWildbookApi: ${e}`)
      }  
    }
  

      private static async  loadResources() {
        try {
          const loaderState = LoaderStateServiceForRoot.getLoaderStateService()
          loaderState.changeLoaderState({isInProgress: true})
          await Resource.loadResources("ReorganizeDatabaseAfterChange");
          await Resource.loadSyncWrapper()
  
        } catch( e ) {
          ReorganizeDatabaseAfterChange.errorMessage(`loadResources: ${e}`)
        }
      }


      private static errorMessage( message: string) {
        console.error("ReornaizeDataabaseAfterChange." + message)
      }

      private static infoMessage( message: string) {
        console.log("ReornaizeDataabaseAfterChange." + message)
      }


}